export default "__VITE_ASSET__9da795b0__"